/* eslint-disable max-len */
import { createImmutableSelector } from 'utils/reselect'
import { isValidSearchQuery } from 'utils/contact_management'
import { List as ImmutableList, Map as ImmutableMap } from 'immutable'

// DATA
const getData = state => state.journalists.get('data')

export const getJoDaJournalists = state => getData(state).get('journalists')
export const getJoDaMyContacts = state => getData(state).get('myContacts')
export const getJoDaAllJournalists = createImmutableSelector(
  getJoDaJournalists,
  getJoDaMyContacts,
  (journalists, myContacts) => journalists.get('items').concat(myContacts.get('items'))
)

export const getJoDaJournalistById = (state, id) => getJoDaAllJournalists(state).find(j => j.get('id') === id) || ImmutableMap()
export const getJoDaMyContactById = (state, id) => getJoDaMyContacts(state).get('items').find(j => j.get('id') === id) || ImmutableMap()

export const getJoDaOutlets = state => getData(state).get('outlets')
export const getJoDaArticles = state => getData(state).get('articles')
export const getJoDaDistributionLists = state => getData(state).get('distributionLists')

export const getJoDaNews = state => getData(state).get('news')
export const getJoDaPublications = state => getData(state).get('publications') || ImmutableList()
export const getJoDaJobTitles = state => getData(state).get('jobTitles') || ImmutableList()

export const getJoDaJournalistsTotals = state => getData(state)
  .filter((_v, k) => ['journalists', 'myContacts'].includes(k))
  .map(d => d.get('total'))

// UI
const getUi = state => state.journalists.get('ui')

export const getJoUiSimpleSearch = state => getUi(state).get('simpleSearch')

export const getJoUiRequestRunning = state => getUi(state).get('requestRunning')
export const getJoUiImportJournalistRequestRunning = state => getUi(state).get('importJournalistRequestRunning')
export const getJoUiFetchPublicationsRequestRunning = state => getUi(state).get('fetchPublicationsRequestRunning')
export const getJoUiFetchIptcMediaTopicsRequestRunning = state => getUi(state).get('fetchIptcMediaTopicsRequestRunning')
export const getJoUiNewsRequestRunning = state => getUi(state).get('fetchNewsRequestRunning')

export const getJoUiModuleReady = state => getUi(state).get('moduleReady')
export const getJoUiDetailPageJournalistId = state => getUi(state).get('detailPageJournalistId')

export const getJoUiDistributionListsDialogOpen = state => getUi(state).get('distributionListsDialogOpen')
export const getJoUiSearchDlRequestRunning = state => getUi(state).get('searchDlRequestRunning')
export const getJoUiDistributionListsDialogJoIds = state => getUi(state).get('distributionListsDialogJoIds')
export const getJoUiSelectedJournalistIds = state => getUi(state).get('selectedJournalistIds')
export const getJoUiSelectedDistributionLists = state => getUi(state).get('selectedDistributionLists')
export const getJoUiNewDistributionLists = state => getUi(state).get('newDistributionLists')

export const getJoUiPristine = state => getUi(state).get('pristine')
export const getJoUiIptcMediaTopicsDialogOpen = state => getUi(state).get('iptcMediaTopicsDialogOpen')
export const getJoUiIptcMediaTopicsExpandedIds = state => getUi(state).getIn(['iptcMediaTopics', 'expandedIds'])
export const getJoUiIptcMediaTopicsSearchQuery = state => getUi(state).getIn(['iptcMediaTopics', 'searchQuery'])
export const getJoUiIptcMediaTopicsSearchInDefinitions = state => getUi(state).getIn(['iptcMediaTopics', 'searchInDefinitions'])
export const getJoUiSearchJobTitlesRequestRunning = state => getUi(state).get('searchJobTitlesRequestRunning')
export const getJoUiAnimateSearchBtn = state => getUi(state).get('animateSearchBtn')
export const getJoUiShowTopicHelperText = state => getUi(state).get('showTopicHelperText')

// PAGINATION
export const getJournalistPagination = state => state.journalists.getIn(['pagination', 'journalists'])
export const getMyContactsPagination = state => state.journalists.getIn(['pagination', 'myContacts'])

// FILTERS
const getJoFilters = state => state.journalists.get('filters')

export const getJoFiQuery = state => getJoFilters(state).get('query')
export const getJoFiFirstName = state => getJoFilters(state).get('firstName')
export const getJoFiLastName = state => getJoFilters(state).get('lastName')
export const getJoFiJobTitles = state => getJoFilters(state).get('jobTitles')
export const getJoFiCountries = state => getJoFilters(state).get('countries') || ImmutableList()
export const getJoFiStates = state => getJoFilters(state).get('states') || ImmutableList()
export const getJoFiTags = state => getJoFilters(state).get('tags') || ImmutableList()
export const getJoFiMediaTypes = state => getJoFilters(state).get('mediaTypes') || ImmutableList()
export const getJoFiChannels = state => getJoFilters(state).get('channels') || ImmutableList()
export const getJoFiLanguages = state => getJoFilters(state).get('languages') || ImmutableList()
export const getJoFiPublications = state => getJoFilters(state).get('publicationIds') || ImmutableList()
export const getJoFiIptcMediaTopics = state => getJoFilters(state).get('iptcMediaTopics') || ImmutableList()

// CALCULATED

export const getJoFiHasFiltersSelected = createImmutableSelector(
  getJoFiQuery,
  getJoFiFirstName,
  getJoFiLastName,
  getJoFiJobTitles,
  getJoFiCountries,
  getJoFiLanguages,
  getJoFiMediaTypes,
  getJoFiChannels,
  getJoFiPublications,
  getJoFiIptcMediaTopics,
  (query, firstName, lastName, jobTitles, countries, languages, mediaTypes, channels, publications, iptcMediaTopics) => {
    const hasFiltersSelected = query.length > 2 || Boolean(firstName.length) || Boolean(lastName.length) || jobTitles.size > 0
      || countries.size > 0 || languages.size > 0
      || mediaTypes.size > 0 || channels.size > 0 || publications.size > 0
      || iptcMediaTopics.size > 0

    return hasFiltersSelected
  }
)

export const getJoFiSearchFormIsValid = createImmutableSelector(
  getJoFiHasFiltersSelected,
  getJoFiQuery,
  getJoFiFirstName,
  getJoFiLastName,
  (hasFilterSelected, query, firstName, lastName) => (
    isValidSearchQuery(query) && isValidSearchQuery(firstName) && isValidSearchQuery(lastName) && hasFilterSelected
  )
)

export const getJoUiDetailPageJournalist = createImmutableSelector(
  getJoUiDetailPageJournalistId,
  getJoDaAllJournalists,
  (id, journalists) => journalists.find(j => j.get('id') === id) || ImmutableMap()
)

export const getJournalistsSearchBody = createImmutableSelector(
  getJoFiQuery,
  (state, type) => (type === 'myContactsPagination' ? getMyContactsPagination(state) : getJournalistPagination(state)),
  getJoFiCountries,
  getJoFiStates,
  getJoFiLanguages,
  getJoFiJobTitles,
  getJoFiMediaTypes,
  getJoFiChannels,
  getJoFiPublications,
  getJoFiFirstName,
  getJoFiLastName,
  getJoFiIptcMediaTopics,
  (_state, type) => type,
  (query, pagination, countryIds, stateIds, languageIds, jobTitles, mediaTypeIds, channelIds, publicationIds, firstName, lastName, iptcMediaTopicIds, type) => {
    const sortDirection = pagination.get('sortDirection')
    const sortBy = pagination.get('sortBy')
    let searchIn = ['all_contacts', 'my_contacts']

    const contact = {
      first_name: [firstName],
      last_name: [lastName],
      job_title: jobTitles,
      country_id: countryIds,
      state_id: stateIds,
      language_ids: languageIds,
      iptc_media_topic_ids: iptcMediaTopicIds
    }

    const publication = {
      channel_id: channelIds,
      media_type_id: mediaTypeIds,
      id: publicationIds
    }

    const paginationBody = {
      page: pagination.get('page'),
      size: pagination.get('size')

    }

    if (type && type === 'allContactsPagination') {
      searchIn = ['all_contacts']
    } else if (type && type === 'myContactsPagination') {
      searchIn = ['my_contacts']
    }

    return {
      queries: [query],
      contact,
      publication,
      pagination: paginationBody,
      sort_by: sortBy,
      sort_order: sortDirection,
      search_in: searchIn
    }
  }
)
